import React, { useEffect, useState} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";


function Simulate(props) {

	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		props.simulate(props.id);
		setTimeout(() => {
			setIsReady(true);
		}, 2000);
	}, []);


	return isReady ? (
		props.productid ? (
			<Redirect to={`/portal/products/${props.productid}/links/0`} />
		) : (
			<Redirect to="/" />
		)
	) : (
		<LayoutSplashScreen />
	);
	
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Simulate);